import React, { useState, useContext, useEffect } from "react";
import Layout from "layouts/LayoutMasterDetail";

import { StoreContext } from "shared/context/store-context";
import { paymentMethods } from "shared/util/types";
import { getContractYearLabel } from "shared/util/relationaldata";

import WithdrawItem from "./WithdrawItem";

const WithdrawsList = () => {
  const itemType = "withdraw";
  const listName = "main_withdraws";

  const { withdraws, selectedEducationYearId, DeleteWithdraw, UpdateWithdraw, InsertWithdraw } =
    useContext(StoreContext);

  const [pageItems, setPageItems] = useState();

  useEffect(() => {
    setPageItems(withdraws.filter((item) => item?.contract?.year === selectedEducationYearId));
  }, [selectedEducationYearId, withdraws]);

  const listColumns = [
    {
      field: "school",
      headerName: "Okul",
      width: 300,
      valueGetter: (params) => {
        try {
          return params.row.contract.school.name;
        } catch (e) {
          console.log(e);
          return "-";
        }
      },
    },

    {
      field: "year",
      headerName: "Yıl",
      width: 130,
      valueGetter: (params) => {
        try {
          return getContractYearLabel(params.row.contract.year);
        } catch (e) {
          return "-";
        }
      },
    },

    {
      field: "contract",
      headerName: "Öğrenci - Fatura İsmi",
      width: 500,
      valueGetter: (params) => {
        try {
          return `${params?.row.contract.student.name ? params?.row?.contract.student.name : "?"} - ${
            params.row.contract?.payerName ? params.row.contract.payerName : "?"
          }`;
        } catch (e) {
          return "-";
        }
      },
    },

    { field: "amount", headerName: "Meblağ", width: 150 },

    {
      field: "date",
      headerName: "İade Tarihi",
      width: 150,
    },
    {
      field: "paymentMethod",
      headerName: "Ödeme Yöntemi",
      width: 150,

      valueGetter: (params) => {
        try {
          return paymentMethods.find((item) => item.value.toString() === params.row.paymentMethod.toString())?.label;
        } catch (e) {
          return "";
        }
      },
    },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={WithdrawItem}
      NewItemComponent={WithdrawItem}
      DeleteItem={DeleteWithdraw}
      InsertItem={InsertWithdraw}
      UpdateItem={UpdateWithdraw}
      hideCreateNewItemWhenSelected={true}
      showSelectedYear={true}
    />
  );
};

export default WithdrawsList;
